import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MergeFilledSvg from "@ant-design/icons-svg/es/asn/MergeFilled";
import AntdIcon from "../components/AntdIcon";
var MergeFilled = function MergeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MergeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MergeFilled.displayName = 'MergeFilled';
}
export default /*#__PURE__*/React.forwardRef(MergeFilled);